import React from 'react'

interface DinersClubIconProps {
  width?: number
  height?: number
  className?: string
}

const DinersClubIcon: React.FC<DinersClubIconProps> = ({
  width = 35,
  height = 24,
  className = '',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 35 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="0.5"
        y="0.5"
        width="34"
        height="23"
        rx="3.5"
        fill="white"
        stroke="#D9D9D9"
      />
      <g transform="translate(8, 5)">
        <path
          d="M11.045 14.4999C14.9425 14.5187 18.5 11.2921 18.5 7.36695C18.5 3.07493 14.9425 0.107835 11.045 0.109437H7.69063C3.74666 0.107835 0.5 3.07573 0.5 7.36695C0.5 11.2929 3.74666 14.5187 7.69063 14.4999H11.045Z"
          fill="#0079BE"
        />
        <path
          d="M7.70666 0.704224C4.10234 0.705425 1.18211 3.65329 1.18091 7.29166C1.18211 10.9296 4.10234 13.8775 7.70666 13.8787C11.3114 13.8775 14.2328 10.9296 14.2332 7.29166C14.2328 3.65329 11.3118 0.705425 7.70666 0.704224ZM3.57044 7.29166C3.56968 6.45044 3.82272 5.62855 4.29648 4.93342C4.77024 4.23829 5.44268 3.70225 6.22592 3.39535V11.1876C5.44262 10.8809 4.77009 10.3449 4.29631 9.64985C3.82253 8.95476 3.56954 8.13286 3.57044 7.29166ZM9.18701 11.1892V3.39495C9.97083 3.70141 10.6439 4.23741 11.118 4.93277C11.5921 5.62813 11.8452 6.45045 11.8441 7.29206C11.845 8.13363 11.5918 8.95588 11.1178 9.65121C10.6437 10.3465 9.97074 10.8826 9.18701 11.1892Z"
          fill="white"
        />
      </g>
    </svg>
  )
}

export default DinersClubIcon
